import React from 'react'

import i18n from 'live/services/i18n'

import { AlarmsTitleContainer, SaveButton } from './styles'

interface IProps {
    handleSave: () => Promise<void>
}

export const AlarmSettingsTitle: React.FC<IProps> = ({ handleSave }) => {
    return (
        <AlarmsTitleContainer>
            <div className="text">
                <div className="text-title">{i18n('WELCOME')}</div>
                <div className="text-body">
                    {i18n('Here you can customize your subscriptions, notifications and reports.')}
                    <br />
                    {i18n('Every option you subscribe to will reflect on all notification settings.')}
                </div>
            </div>
            <div className="save-notification-settins">
                <SaveButton onClick={() => handleSave()}>{i18n('SAVE')}</SaveButton>
            </div>
        </AlarmsTitleContainer>
    )
}
